import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LanguageContext";
import { t, LANGS } from "@/lib/i18n";

export default function SettingsPage() {
  const { user } = useAuth();
  const { lang, setLang } = useLang();

  return (
    <div className="space-y-6 max-w-2xl" data-testid="settings-page">
      <h1 className="font-display font-light text-3xl tracking-tight">
        {t(lang, "settings_title")}
      </h1>

      <div className="hq-card p-6">
        <div className="font-mono text-[10px] uppercase tracking-widest text-white/40 mb-3">
          {t(lang, "settings_profile")}
        </div>
        <div className="space-y-2 font-mono text-sm">
          <Row k="user_id" v={user?.user_id} />
          <Row k="email" v={user?.email} />
          <Row k="name" v={user?.name} />
          <Row k="role" v={user?.role} />
          <Row k="provider" v={user?.auth_provider} />
        </div>
      </div>

      <div className="hq-card p-6">
        <div className="font-mono text-[10px] uppercase tracking-widest text-white/40 mb-3">
          {t(lang, "settings_language")}
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-5 gap-2">
          {LANGS.map((l) => (
            <button
              key={l.code}
              data-testid={`settings-lang-${l.code}`}
              onClick={() => setLang(l.code)}
              className={`hq-btn ${
                lang === l.code ? "hq-btn-cyan" : "hq-btn-ghost"
              } justify-start`}
            >
              <span className="font-mono text-xs uppercase w-6">{l.code}</span>
              <span className="truncate">{l.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

function Row({ k, v }) {
  return (
    <div className="flex items-baseline gap-4">
      <span className="text-white/40 w-24 shrink-0">{k}</span>
      <span className="text-white/90 truncate">{v || "—"}</span>
    </div>
  );
}
